module.exports = __webpack_public_path__ + "img/q_img07.fb818d60.jpg";